module.exports = __webpack_public_path__ + "static/media/redd.f4cffa7f.jpeg";